export default "__VITE_ASSET__ByB_5XbI__"